<template>
  <div class="forms">
    <!-- Steps whose content already says what it is (a grid of salons, a list of
         services) opt out of the heading via `show_head` — it only cost screen. -->
    <div class="non-printable panel-head" v-if="showHead">
      <h4 class="panel-title">{{ $t(title) }}</h4>
      <p class="panel-subtitle" v-if="detail">{{ $t(detail) }}</p>
    </div>
    <component :is="dynamicComponent" @tab-change="nextTabChange" @on-reset="resetApp" :wizardNext="wizardNext" :wizardPrev="wizardPrev"></component>
  </div>
</template>
<script setup>
// Library
import { computed, ref } from 'vue'
import { useRequest } from '@/helpers/hooks/useCrudOpration'
import {useQuickBooking} from '../store/quick-booking'

// Select Options List Request
import { STORE_URL } from '@/vue/constants/quick_booking'

const {  storeRequest } = useRequest()


// Components
import NotFound from './NotFound.vue'
import SelectBranch from './BookingComponent/SelectBranch.vue'
import SelectDateTime from './BookingComponent/SelectDateTime.vue'
import SelectService from './BookingComponent/SelectService.vue'
import SelectStaff from './BookingComponent/SelectStaff.vue'
import Confirmation from './BookingComponent/Confirmation.vue'
import CustomerDetail from './BookingComponent/CustomerDetail.vue'
import ConfirmationDetail  from './BookingComponent/ConfirmationDetail.vue'
import Error from './BookingComponent/Error.vue'

const IS_RESETTING = ref(false)

const props = defineProps({
  wizardNext: {
    default: '',
    type: [String, Number]
  },
  wizardPrev: {
    default: '',
    type: [String, Number]
  },
  type: {
    type: String
  },
  title: {
    type: String
  },
  detail: {
    type: String,
    default: ''
  },
  showHead: {
    type: Boolean,
    default: true
  }
})

const dynamicComponent = computed(() => {
  switch (props.type) {
    case 'select-branch':
      return SelectBranch
      break

    case 'select-date-time':
      return SelectDateTime
      break

    case 'select-service':
      return SelectService
      break

    case 'select-employee':
      return SelectStaff
      break

    case 'select-confirm':
      return Confirmation
      break

    case 'customer-details':
      return CustomerDetail
      break

    case 'confirmation-detail':
      return ConfirmationDetail
      break

    case 'error':
      return Error
      break

    default:
      return NotFound
      break
  }
})

const emit = defineEmits(['onClick'])

const store = useQuickBooking()
const booking = computed(() => store.booking)
const user = computed(() => store.user)
const normalizeErrorMessage = (payload) => {
  if (typeof payload === 'string') {
    return payload
  }

  if (payload?.response?.data) {
    return normalizeErrorMessage(payload.response.data)
  }

  if (typeof payload?.message === 'string') {
    return payload.message
  }

  if (payload?.message && typeof payload.message === 'object') {
    return Object.values(payload.message).flat().join(' ')
  }

  if (payload?.errors && typeof payload.errors === 'object') {
    return Object.values(payload.errors).flat().join(' ')
  }

  return 'Something went wrong. Please try again.'
}

const nextTabChange = (value) => {
  if(value == 6){
    const body = {
      user: user.value,
      booking: booking.value
    }
    storeRequest({ url: STORE_URL , body : body }).then((res) => {
      if (res.status) {
        store.updateBookingResponse(res.data)
        emit('onClick', value)
      } else {
        store.setErrorMessage(normalizeErrorMessage(res))
        emit('onClick', 8)
      }
    }).catch((error) => {
      store.setErrorMessage(normalizeErrorMessage(error))
      emit('onClick', 8)
    })
  }
  else{
    emit('onClick', value)
  }
}

const resetApp = () => {
  store.resetState()
  emit('onClick', 1)
}
</script>
